export const localeLanguages: Record<
    string,
    { locales: string[]; main_nation: string }
> = {
    en: {
        main_nation: 'gb',
        locales: [
            'ag',
            'ai',
            'as',
            'au',
            'bb',
            'bm',
            'bs',
            'bz',
            'cc',
            'ck',
            'dm',
            'er',
            'fj',
            'fk',
            'fm',
            'gd',
            'gg',
            'gh',
            'gi',
            'gm',
            'gu',
            'gy',
            'hm',
            'ie',
            'im',
            'io',
            'je',
            'jm',
            'ki',
            'kn',
            'ky',
            'lc',
            'lr',
            'ls',
            'mh',
            'mp',
            'ms',
            'mt',
            'mu',
            'mw',
            'na',
            'nf',
            'ng',
            'nr',
            'nu',
            'nz',
            'pg',
            'pn',
            'pw',
            'sb',
            'sc',
            'sd',
            'sg',
            'sh',
            'sl',
            'ss',
            'sz',
            'tc',
            'tk',
            'to',
            'tt',
            'tv',
            'tz',
            'ug',
            'um',
            'vc',
            'vg',
            'vi',
            'vu',
            'za',
            'zm',
            'zw',
        ],
    },
    us: {
        main_nation: 'us',
        locales: [
            'us',
            'us-ak',
            'us-al',
            'us-ar',
            'us-az',
            'us-ca',
            'us-co',
            'us-ct',
            'us-de',
            'us-fl',
            'us-ga',
            'us-hi',
            'us-ia',
            'us-id',
            'us-il',
            'us-in',
            'us-ks',
            'us-ky',
            'us-la',
            'us-ma',
            'us-md',
            'us-me',
            'us-mi',
            'us-mn',
            'us-mo',
            'us-ms',
            'us-mt',
            'us-nc',
            'us-nd',
            'us-ne',
            'us-nh',
            'us-nj',
            'us-nm',
            'us-nv',
            'us-ny',
            'us-oh',
            'us-ok',
            'us-or',
            'us-pa',
            'us-ri',
            'us-sc',
            'us-sd',
            'us-tn',
            'us-tx',
            'us-ut',
            'us-va',
            'us-vt',
            'us-wa',
            'us-wi',
            'us-wv',
            'us-wy',
        ],
    },
    es: {
        main_nation: 'es',
        locales: [
            'ar',
            'bo',
            'cl',
            'co',
            'cr',
            'cu',
            'do',
            'ec',
            'es',
            'gq',
            'gt',
            'hn',
            'mx',
            'ni',
            'pa',
            'pe',
            'pr',
            'py',
            'sv',
            'uy',
            've',
        ],
    },
    ar: {
        main_nation: 'sa',
        locales: [
            'ae',
            'bh',
            'dz',
            'eg',
            'eh',
            'iq',
            'jo',
            'kw',
            'lb',
            'ly',
            'ma',
            'mr',
            'om',
            'ps',
            'qa',
            'sa',
            'sd',
            'sy',
            'tn',
            'ye',
        ],
    },
    fr: {
        main_nation: 'fr',
        locales: [
            'bf',
            'bi',
            'bj',
            'bl',
            'cd',
            'cf',
            'cg',
            'ci',
            'cm',
            'dj',
            'fr',
            'ga',
            'gf',
            'gn',
            'gp',
            'mc',
            'ml',
            'mq',
            'nc',
            'ne',
            'pf',
            'pm',
            're',
            'rw',
            'sc',
            'sn',
            'sy',
            'td',
            'tf',
            'tg',
            'wf',
            'yt',
        ],
    },
    de: {
        main_nation: 'de',
        locales: ['at', 'ch', 'de', 'li', 'lu'],
    },
    zh: {
        main_nation: 'cn',
        locales: ['cn', 'hk', 'mo', 'tw'],
    },
    pt: {
        main_nation: 'pt',
        locales: ['ao', 'br', 'cv', 'gw', 'mz', 'pt', 'st', 'tl'],
    },
    ru: {
        main_nation: 'ru',
        locales: ['ru'],
    },
    it: {
        main_nation: 'it',
        locales: ['it', 'sm'],
    },
    nl: {
        main_nation: 'nl',
        locales: ['aw', 'bq', 'cw', 'nl', 'sr', 'sx'],
    },
    sv: {
        main_nation: 'se',
        locales: ['se', 'ax'],
    },
    tr: {
        main_nation: 'tr',
        locales: ['tr', 'cy'],
    },
    cs: {
        main_nation: 'cz',
        locales: ['cz'],
    },
    da: {
        main_nation: 'dk',
        locales: ['dk'],
    },
    el: {
        main_nation: 'gr',
        locales: ['cy', 'gr'],
    },
    fi: {
        main_nation: 'fi',
        locales: ['fi'],
    },
    hu: {
        main_nation: 'hu',
        locales: ['hu'],
    },
    is: {
        main_nation: 'is',
        locales: ['is'],
    },
    ja: {
        main_nation: 'jp',
        locales: ['jp'],
    },
    ko: {
        main_nation: 'kr',
        locales: ['kr', 'kp'],
    },
    ms: {
        main_nation: 'my',
        locales: ['bn', 'my'],
    },
    no: {
        main_nation: 'no',
        locales: ['bv', 'no', 'sj'],
    },
    pl: {
        main_nation: 'pl',
        locales: ['pl'],
    },
    ro: {
        main_nation: 'ro',
        locales: ['md', 'ro'],
    },
    sk: {
        main_nation: 'sk',
        locales: ['sk'],
    },
    sl: {
        main_nation: 'si',
        locales: ['si'],
    },
    sr: {
        main_nation: 'rs',
        locales: ['me', 'rs'],
    },
    bg: {
        main_nation: 'bg',
        locales: ['bg'],
    },
    he: {
        main_nation: 'il',
        locales: ['il'],
    },
    vi: {
        main_nation: 'vn',
        locales: ['vn'],
    },
    am: {
        main_nation: 'et',
        locales: ['et'],
    },
    id: {
        main_nation: 'id',
        locales: ['id'],
    },
    ka: {
        main_nation: 'ge',
        locales: ['ge'],
    },
    fa: {
        main_nation: 'ir',
        locales: ['af', 'ir'],
    },
    hy: {
        main_nation: 'am',
        locales: ['am'],
    },
    sq: {
        main_nation: 'al',
        locales: ['al', 'xk'],
    },
    az: {
        main_nation: 'az',
        locales: ['az'],
    },
    bs: {
        main_nation: 'ba',
        locales: ['ba'],
    },
    bn: {
        main_nation: 'bd',
        locales: ['bd'],
    },
    be: {
        main_nation: 'by',
        locales: ['by'],
    },
    dz: {
        main_nation: 'bt',
        locales: ['bt'],
    },
    kk: {
        main_nation: 'kz',
        locales: ['kz'],
    },
    lo: {
        main_nation: 'la',
        locales: ['la'],
    },
    mg: {
        main_nation: 'mg',
        locales: ['mg'],
    },
    mk: {
        main_nation: 'mk',
        locales: ['mk'],
    },
    my: {
        main_nation: 'mm',
        locales: ['mm'],
    },
    mn: {
        main_nation: 'mn',
        locales: ['mn'],
    },
    ne: {
        main_nation: 'np',
        locales: ['np'],
    },
    si: {
        main_nation: 'lk',
        locales: ['lk'],
    },
    tk: {
        main_nation: 'tm',
        locales: ['tm'],
    },
    ur: {
        main_nation: 'pk',
        locales: ['pk'],
    },
    uk: {
        main_nation: 'ua',
        locales: ['ua'],
    },
    uz: {
        main_nation: 'uz',
        locales: ['uz'],
    },
};
